module.exports = __webpack_public_path__ + "img/H.c27bcb56.png";